import React from "react";
import { useState } from "react";
import { motion } from "framer-motion";
import { useParallax } from "react-scroll-parallax";
import Lottie from "lottie-react";
import animationData from "../../MyAnimations/Animation - 1743874727518.json";

// Animation Variants
const imageVariant = {
  hidden: { x: "100vw", opacity: 0 }, // Image moves in from the right
  visible: { x: 0, opacity: 1, transition: { duration: 1.5, ease: "easeOut" } },
};

const fadeUpVariant = {
  hidden: { y: 50, opacity: 0 },
  visible: (delay) => ({
    y: 0,
    opacity: 1,
    transition: { duration: 0.8, ease: "easeOut", delay },
  }),
};

const DataBaseSection
 = () => {
  const parallax = useParallax({ translateY: [-24, 24], rootMargin: 0 });
  const [isMobile, setIsMobile] = useState(window.innerWidth < 670);


  return (
    <section className="work-area pt-110 bg-[#292930] text-white" style={{paddingTop : isMobile && 50, paddingBottom : isMobile && 50}}>
      <div className="container">
        <div className="content-wrapper">
          {/* Left Content */}
          <motion.div
            className="text-container"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            <motion.h2 variants={fadeUpVariant} custom={0.2}>
            <div className="section-title title-style-two white-title mb-30">
                <span className="sub-title">Database</span>
                <h2 className="title" style={{fontSize : isMobile ? "28px" : "40px"}}>Database Management</h2>
              </div>
            </motion.h2>

            {/* Icons */}
            <motion.div className="tech-icons" variants={fadeUpVariant} custom={0.4}>
              <img src="/Images/LandingPage/MongoDB.jpg" alt="MongoDB" />
              <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR_HzGs1ZFhveY4N9eEv6UqXk3MdDDVZ2M_gBmDgYFAwbEokieOhFexs4t1T9K7q2Cr18U&usqp=CAU" alt="SQL" />
              <img  src="https://banner2.cleanpng.com/20180315/eaq/av0cw3km1.webp" alt="PostgreSQL" />
            </motion.div>

            {/* Content */}
            <motion.ul className="info-list">
              <motion.li variants={fadeUpVariant} custom={1.0} style={{color :"#b8b8c5"}}>
                ⚡ Proficient in database design, data modeling, and normalization techniques to ensure efficient data organization and integrity.
              </motion.li>
              <motion.li variants={fadeUpVariant} custom={1.5} style={{color :"#b8b8c5"}}>
                ⚡ Experienced in working with both relational (SQL) and NoSQL databases, handling data storage, retrieval, and management effectively.
              </motion.li>
              <motion.li variants={fadeUpVariant} custom={2.0} style={{color :"#b8b8c5"}}>
                ⚡ Skilled in optimizing database performance through indexing, query tuning, and efficient schema design to enhance speed and scalability.
              </motion.li>
              <motion.li variants={fadeUpVariant} custom={2.5} style={{color :"#b8b8c5"}}> 
                ⚡ Knowledgeable in implementing robust database security measures, including access control, encryption, and backup strategies to safeguard data.
              </motion.li>
            </motion.ul>
          </motion.div>

          {/* Right Image */}
          <motion.div
            className="image-container"
            variants={imageVariant}
            initial="hidden"
            animate="visible"
            style={{ marginTop: "-50px" }}
          >
            <Lottie animationData={animationData} loop={true} style={{ width: !isMobile ? "90%" : "100%", marginTop : !isMobile ? "100px" : "30px", marginLeft : !isMobile ? "50px" : "0px"}} />
          </motion.div>
        </div>
      </div>

      {/* Styling */}
      <style jsx>{`
        .database-section {
          padding: 4rem 2rem;
          background-color: #292930;
        }

        .container {
          max-width: 1200px;
          margin: 0 auto;
        }

        .content-wrapper {
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-wrap: wrap;
        }

        .image-container {
          flex: 1;
          display: flex;
          justify-content: center;
          max-width: 50%;
        }

        .image-container img {
          width: 100%;
          max-width: 500px;
        }

        .text-container {
          flex: 1;
          max-width: 50%;
          text-align: left;
        }

        h2 {
          font-size: 2rem;
          color: white;
          margin-bottom: 1rem;
        }

        .tech-icons {
          display: flex;
          gap: 10px;
          margin-bottom: 1rem;
        }

        .tech-icons img {
          width: 40px;
          height: 40px;
        }

        .info-list {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .info-list li {
          font-size: 1rem;
          color: white;
          margin-bottom: 0.75rem;
        }

        /* Responsive Design */
        @media (max-width: 1024px) {
          .content-wrapper {
            flex-direction: column-reverse;
            text-align: center;
          }

          .image-container,
          .text-container {
            max-width: 100%;
          }

          .text-container {
            margin-top: 2rem;
          }
        }
      `}</style>

      <div className="work-shape-wrap">
        <img src="/img/images/work_shape05.png" alt="" />
        <img src="/img/images/work_shape04.png" alt="" ref={parallax.ref} />
        <img src="/img/images/work_shape03.png" alt="" />
        {/* <img src="/img/images/work_shape02.png" alt="" /> */}
        <img src="/img/images/work_shape01.png" alt="" />
      </div>
    </section>
  );
};

export default DataBaseSection;